import { render, staticRenderFns } from "./ReceivingConfirmation.vue?vue&type=template&id=467b1730&"
import script from "./ReceivingConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReceivingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports